import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;

  inset: 0;

  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
`

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  width: 100vw;

  animation: from-below 0.3s ease forwards;

  @media only screen and (min-width: 800px) {
    width: fit-content;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    animation: none;
  }

  @keyframes from-below {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`
